













import Vue from 'vue'
export default Vue.extend({
  props: {
    facetId: {
      type: String,
      required: false,
      default: ''
    },
    open: {
      type: Boolean,
      default: true
    }
  },
  data(): {
    toggleParent: boolean
  } {
    return {
      toggleParent: this.open
    }
  },
  methods: {
    toggleSection() {
      this.toggleParent = !this.toggleParent
      this.$emit('toggleSection', {
        toggle: this.toggleParent,
        id: this.facetId
      })
    }
  }
})
